<template>
  <div>
    <el-input class="search-el" size="mini" v-model="query.name" clearable placeholder="请输入名称"></el-input>

    <el-select class="search-el" size="mini" v-model="query.object_type" placeholder="全部" clearable filterable>
      <el-option label="未关联" value="0"></el-option>
      <el-option label="已关联" value="1"></el-option>
      <el-option label="全部" value="-1"></el-option>
    </el-select>

    <el-select class="search-el" size="mini" v-model="query.experience_type" placeholder="选择体验营类型" clearable filterable>
      <el-option v-for="item in this.type_list" :key="item.key" :label="item.value" :value="item.key">
      </el-option>
    </el-select>

    <el-button type="primary" size="mini" @click="getList()"> 查询 </el-button>
    <el-button type="primary" size="mini" @click="setChoice()"> 批量设置自动关联 </el-button>
    <span style="font-size: 10px; color: #D9001B;line-height: normal;position:absolute;margin-left: 10px;">
      <p>使用批量设置自动关联前，须先对课程设置一个对应的体验营类型课程</p>
    </span>

    <el-button size="mini" type="danger" @click="wechatShopDecryptOperate()" :loading="decrypt_loading"
      style="margin-left: 350px;">微信小店解密重置
    </el-button>
    <el-row>
      <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0;"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="name" label="名称" align="center" min-width="20%">
          <template slot-scope="{ row }">
            {{ row.name }}
            <div v-if="row.app_id != null">
              {{ row.app_name }}<br />
              商品编码：{{ row.xiao_id }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="图片" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px;" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="价格" align="center" min-width="5%" prop="unit_price">
        </el-table-column>
        <el-table-column label="同步时间" align="center" min-width="12%" prop="created_at">
        </el-table-column>

        <el-table-column label="状态" align="center" min-width="12%">
          <template slot-scope="{ row }">
            <span v-if="row.object_type > 0" style="color: #67c23a;"><i class="el-icon-circle-check"></i> {{
              row.status_msg }}</span>
            <span v-else style="color: #909399;"><i class="el-icon-circle-close"></i> {{ row.status_msg }}</span>
            <el-button size="mini" type="text" style="margin-left: 5px;" @click="
                sid = row.id;
                object_type = row.object_type;
                is_experience = row.is_experience;
                is_experience_type = 1;
                search.chooseOrgVisible = true;
                searchData();
              ">
              {{ row.object_type == 0 ? '设置' : '修改' }}
            </el-button>

            <span v-if="row.is_experience == 1">
              <el-button size="medium" style="margin-left: 5px;" @click="
                  sid = row.id;
                  relation.chooseOrgVisible = true;
                  getRelationExpData();
                ">设置自动关联 ({{ row.exp_relation_count }})
              </el-button>
            </span>
          </template>
        </el-table-column>

        <el-table-column label="管理时间" align="center" min-width="8%" prop="updated_at">
        </el-table-column>

        <el-table-column label="关联对象" align="center" min-width="15%">
          <template slot-scope="{ row }">
            <div v-if="row.object_type > 0">
              {{ row.object_type_msg }}
              <div v-if="row.object_id > 0">
                ID: {{ row.object_id }}<br />
                {{ row.extra.title }}
              </div>
              <div v-if="row.kk_time != ''">
                {{ row.kk_time }}
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-row>

    <el-dialog title="选择课程" :visible.sync="search.chooseOrgVisible" :close-on-click-modal="true"
      :before-close="addEditFormOnClose" width="75%">
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input size="mini" v-model="search.query.search" placeholder="请输入标题" clearable @blur="searchData()" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="searchData()">
            查询课程
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="mini" @click="selectProduct({ course_type: 7, id: 0 })">
            设为电商商品
          </el-button>
        </el-form-item>
      </el-form>

      <el-tabs v-model="search.activeName" @tab-click="handleClick">
        <el-tab-pane label="普通课程" name="1"></el-tab-pane>
        <el-tab-pane label="直播课" name="3"></el-tab-pane>
        <el-tab-pane label="线下课" name="5"></el-tab-pane>
        <el-tab-pane label="专题课" name="12"></el-tab-pane>
        <el-tab-pane label="有声书" name="6"></el-tab-pane>
        <el-tab-pane label="个案咨询" name="16"></el-tab-pane>
      </el-tabs>

      <!--列表-->
      <el-table border :data="search.result.data" highlight-current-row v-loading="search.listLoading1" style="...">
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column prop="title" label="标题" align="center"></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px;" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="selectProduct(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @current-change="searchData" :current-page.sync="search.query.page"
        :page-size="search.query.limit" layout="total, prev, pager, next, jumper" :total="search.result.total">
      </el-pagination>
    </el-dialog>


    <el-dialog title="体验营设置关联排序" :visible.sync="relation.chooseOrgVisible" :close-on-click-modal="true"
      :before-close="addRelationEditFormOnClose" width="75%">
      <div class="layui-input-inline" style="font-size: 10px; color: #D9001B;line-height: normal;margin-top: -40px;">
        <p>完成自动切换的前提是设置了待关联体验营，且体验营已创建班级和短信；</p>
        <p>①当例子达到分班系统中体验营设置的需求目标量则自动切换</p>
        <p>②时间到了开课首日中午12点自动切换 </p>
        <p>③列表从上往下执行切换，即排序小的优先切换 </p>
        <p>④手动关联为可强制修改当前关联期号，若不想触发自动切换，请删除多余待关联期号</p>
      </div>
      <el-form>
        <el-form-item>
          <el-button type="primary" size="mini" @click="
                add_relation.chooseOrgVisible = true;
                addRelation();
              ">
            添加关联课程
          </el-button>

          <el-button type="primary" size="mini" @click="
              batchDelete()">批量删除
          </el-button>
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table border :data="relation.result.data" highlight-current-row v-loading="relation.listLoading1"
        :stripe="true" style="..." @selection-change="handleRelationCourseChange">
        <el-table-column type="selection" width="55" align="center" :selectable="selectableCallback"></el-table-column>
        <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
        <el-table-column prop="course_id" label="课程ID" align="center" width="90"></el-table-column>
        <el-table-column prop="title" label="名称" align="center"></el-table-column>
        <el-table-column prop="time" label="开课时间" align="center" width="210"></el-table-column>
        <el-table-column prop="status_value" label="关联状态" align="center" width="103"></el-table-column>
        <!--        <el-table-column-->
        <!--            prop="sort"-->
        <!--            label="排序"-->
        <!--            align="center"-->
        <!--            width="109"-->
        <!--        >-->
        <!--          <template slot-scope="{ row }">-->
        <!--            <el-button type="text" size="small" @click="setSort(row.id, row.sort)">-->
        <!--              {{row.sort}}-->
        <!--            </el-button>-->
        <!--          </template>-->
        <!--        </el-table-column>-->

        <el-table-column label="操作" align="center" width="165">
          <template slot-scope="{ row }">
            <span v-if="row.status == 0">
              <el-button type="success" size="mini" @click="handRelation(row)">
                手动关联
              </el-button>
            </span>
            &nbsp;
            <span v-if="row.status != 1">
              <el-button type="primary" size="mini" @click="deleteExperience(row)">
                删除
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>


    <el-dialog title="选择课程" :visible.sync="add_relation.chooseOrgVisible" :close-on-click-modal="true"
      :before-close="addExpEditFormOnClose" width="75%">
      <el-form :inline="true" :model="add_relation.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input size="mini" v-model="add_relation.query.search" placeholder="请输入标题" clearable
            @blur="addExpSearchData()" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="addExpSearchData()">
            查询课程
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table border :data="add_relation.result.data" highlight-current-row v-loading="add_relation.listLoading1"
        style="...">
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column prop="title" label="标题" align="center"></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px;" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="addSelectExperience(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @current-change="addExpSearchData" :current-page.sync="add_relation.query.page"
        :page-size="add_relation.query.limit" layout="total, prev, pager, next, jumper"
        :total="add_relation.result.total">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import { decryptOperate} from "@/api/manage/system/system";
import {screenProductList} from "@/api/coupon";

import {
  getResourceRelationshipList,
  setRelationship,
  getExperienceRelationshipList,
  deleteExpRelationship,
  screenExperienceList,
  setExpRelationship,
  setExpRelationshipSort,
  relationExpRelation,
} from "@/api/xiao";

import {typeInfo} from "@/api/activityCamp";

export default {
  data: function () {
    return {
      decrypt_loading: false,
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        name: "",
        object_type: "-1",
        experience_type: "",
        page: 1,
        limit: 20,
      },

      sid: 0,
      object_type: 0,
      is_experience: 0,
      is_experience_type: 0,
      is_checkbox: 1,
      multipleSelection: '',
      selectionList: [],
      relationCourseSelection: '',
      selectionRelationCourseList: [],
      type_list:[],//体验营类型

      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        activeName: "1",
        query: {
          type: 1,
          search: "",
          page: 1,
          limit: 5,
          target_type: 1,
          extra_type: 2, // 限定非排期课，0-不限（即全部），1-限定搜排期课，2-限定搜非排期课
        },
        result: {
          total: 0,
          data: [],
        },
      },

      relation: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          page: 1,
          order_xiao_target_id: 0,
        },
        result: {
          total: 0,
          data: [],
        },
      },

      add_relation: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          search: "",
          page: 1,
          limit: 5,
          order_xiao_target_id: 0,
          type: 1
        },
        result: {
          total: 0,
          data: [],
        },
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    wechatShopDecryptOperate() {
      this.$confirm("是否将微信小店解密重置？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        decryptOperate().then((response) => {
          if (response.status == 2000) {
            this.$message({
              showClose: true,
              message: response.message,
              type: "success",
            });
          }
        });
      });
    },

    handleClick(tab, event) {
      this.search.query.target_type = Number(tab.name);
      this.searchData();
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.activeName = "1";
      this.search.query.type = 1;
      this.search.query.search = "";
      this.search.query.target_type = 1;

      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
    },

    // 弹窗关闭
    addRelationEditFormOnClose() {
      this.relation.query.page = 1;
      this.relation.result = {
        total: 0,
        data: [],
      };
      this.relation.chooseOrgVisible = false;
      this.getList()
    },

    getRelationExpData(){
      this.relation.query.order_xiao_target_id = this.sid;
      this.relation.listLoading1 = true;
      getExperienceRelationshipList(this.relation.query).then((response) => {
        this.relation.result.data = response.data.list;
        this.relation.result.total = response.data.total;
        this.relation.listLoading1 = false;
      });
    },


    setSort(id, remark) {
      this.$prompt("请输入排序信息", "排序信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: remark,
      }).then(({value}) => {
        setExpRelationshipSort({
          id: id,
          sort: value,
        }).then((response) => {
          if (response.status == 2000) {
            this.getRelationExpData();
            this.$message({
              showClose: true,
              message: "排序设置成功",
              type: "success",
            });
            // eslint-disable-next-line no-empty
          } else {
          }
        });
      });
    },

    deleteExperience(row) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteExpRelationship({
          id: row.id,
          type: 1,
        }).then((response) => {
          if (response.status == 2000) {
            this.getRelationExpData();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          }
        });
      });
    },

    selectableCallback(row, index) { //scope.row.status == 1 状态是【已关联】的时候不可选
      if (row.status == 1) {
        return false;
      } else {
        return true;
      }
    },

    handleRelationCourseChange(val) {
      this.relationCourseSelection = val;
      // 每次都清空存储的数据，并装入新数据
      this.selectionRelationCourseList = [];
      for (const val of this.relationCourseSelection) {
        for (const key in val) {
          if (key === "id") {
            this.selectionRelationCourseList.push(val[key]);
          }
        }
      }
      console.log(this.selectionRelationCourseList);
    },


    batchDelete() {
      if (this.selectionRelationCourseList.length == 0) {
        this.$message.error('请选择数据!')
        return false;
      }
      this.$confirm("此操作将批量删除对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteExpRelationship({
          id: this.selectionRelationCourseList,
          type: 2,
        }).then((response) => {
          if (response.status == 2000) {
            this.getRelationExpData();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          }
        });
      });
    },

    //手动关联
    handRelation(row) {
      this.$confirm("此操作将手动关联, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        relationExpRelation({
          id: row.id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getRelationExpData();
            this.$message({
              showClose: true,
              message: "关联成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },


    // 弹窗关闭
    addExpEditFormOnClose() {
      this.add_relation.query.page = 1;
      this.add_relation.query.search = "";
      this.add_relation.result = {
        total: 0,
        data: [],
      };
      this.add_relation.chooseOrgVisible = false;
    },

    // 查询方法
    addExpSearchData() {
      this.add_relation.listLoading1 = true;
      var isCheckbox = this.is_checkbox
      if (isCheckbox == 2) {
        this.add_relation.query.type = 0;
      } else {
        this.add_relation.query.type = 1;
      }
      this.add_relation.query.order_xiao_target_id = this.sid;
      screenExperienceList(this.add_relation.query).then((response) => {
        this.add_relation.result.data = response.data.list;
        this.add_relation.result.total = response.data.total;
        this.add_relation.listLoading1 = false;
      });
    },

    addSelectExperience(row) {
      var isCheckBox = this.is_checkbox
      setExpRelationship({
        order_xiao_target_id: this.sid,
        course_id: row.id,
        type: isCheckBox,
        selection_list: this.selectionList,
      }).then((response) => {
        if (response.status == 2000) {
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        }
        if (isCheckBox == 1) {
          this.getRelationExpData();
        } else {
          this.getList();
        }
      });
      this.add_relation.chooseOrgVisible = false;
    },

    // 查询方法
    searchData() {
      var isExperience = this.is_experience;
      var objectType = this.object_type;
      var isExperienceType = this.is_experience_type;
      console.log(isExperienceType)
      // eslint-disable-next-line no-empty
      if ((isExperience == 1) && (objectType != 0) && (isExperienceType == 1)) {
        this.is_experience_type = 0
        this.search.chooseOrgVisible = false
        this.$confirm('当前课程已关联体验营，请通过设置自动关联完成修改', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.search.chooseOrgVisible = true
          this.search.listLoading1 = true;
          screenProductList(this.search.query).then((response) => {
            this.search.result.data = response.data.list;
            this.search.result.total = response.data.total;
            this.search.listLoading1 = false;
          });
        }).catch(() => {
          //几点取消的提示
        });
      } else {
        this.search.listLoading1 = true;
        screenProductList(this.search.query).then((response) => {
          this.search.result.data = response.data.list;
          this.search.result.total = response.data.total;
          this.search.listLoading1 = false;
        });
      }
    },
    selectProduct(row) {
      setRelationship({
        id: this.sid,
        object_type: row.course_type,
        object_id: row.id
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        }
      });

      this.sid = 0;
      this.search.chooseOrgVisible = false;
    },

    getList() {
      this.loading = true;
      getResourceRelationshipList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });

      typeInfo({}).then(response => {
        this.type_list = response.data.type_list;
      });
    },

    handleSelectionChange(val) {
      // val拿到的是选中行的全部数据，而this.multipleSelection是把val以对象装在数组中
      this.multipleSelection = val;
      // 每次都清空存储的数据，并装入新数据
      this.selectionList = [];
      for (const val of this.multipleSelection) {
        for (const key in val) {
          if (key === "id") {
            this.selectionList.push(val[key]);
          }
        }
      }
      console.log(this.selectionList);
    },



    //多选
    setChoice() {
      console.log(this.selectionList)
      if (this.selectionList.length == 0) {
        this.$message.error('请选择数据!')
        return false;
      }
      this.is_checkbox = 2;
      this.add_relation.chooseOrgVisible = true;
      this.addExpSearchData();
    },

    //单选
    addRelation() {
      this.is_checkbox = 1;
      console.log(this.is_checkbox)
      this.addExpSearchData();
    },
  },
  mounted() {},
};
</script>
